import { render, staticRenderFns } from "./veStuLiteraryAward.vue?vue&type=template&id=6675e08c&scoped=true"
import script from "./veStuLiteraryAward.vue?vue&type=script&lang=js"
export * from "./veStuLiteraryAward.vue?vue&type=script&lang=js"
import style0 from "./veStuLiteraryAward.vue?vue&type=style&index=0&id=6675e08c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6675e08c",
  null
  
)

export default component.exports